import React, { useContext } from 'react';
import classNames from 'classnames';
import { Field } from 'react-final-form';
import FieldMediaPackages from './components/FieldMediaPackages';
import FieldBuyerOutreach from './components/FieldBuyerOutreach';
import { useTranslation } from 'react-i18next';
import { BuyerOutreach, MediaPackage } from 'models/Listing';
import PatchListingContext from '../../providers/PatchListing/PatchListing.context';
import ResolveProspecting from 'assets/images/resolve-prospecting.webp';
import ResolveImage from 'components/ResolveImage';
import { TILES } from './data';
import { checkIsNoPackage } from 'utils';
import validate from 'validations';
import ListingContext from '../../providers/Listing/Listing.context';

import './MediaBuying.styles.scss';
import './MediaBuying.styles.responsive.scss';

type MeadiaBuyingProps = {
  className?: string;
};

const MeadiaBuying: React.FC<MeadiaBuyingProps> = (props) => {
  const { className } = props;

  const classes = classNames('media-buying', 'lcw-page', className);
  const { patchListingValue } = useContext(PatchListingContext);

  const { t } = useTranslation();

  const {
    listing: { listingPackage },
  } = useContext(ListingContext);

  const isListingNoPackage = checkIsNoPackage(listingPackage);

  return (
    <div className={classes}>
      <div className="media-buying__heading">
        <p className="lcw-page__heading__title">{t('mediaBuyingTitle')}</p>

        <ResolveImage asIllustration src={ResolveProspecting} />
      </div>

      <div className={classNames('media-buying__description', 'white-panel')}>
        <p>{t('twoBuyerOutreachPackages')}</p>

        <div className="tiles">
          {TILES.map(({ description, Icon }) => (
            <div key={description}>
              <p className="icon">
                <Icon />
              </p>

              <p className="description">{t(description)}</p>
            </div>
          ))}
        </div>
      </div>

      <Field
        name="buyerOutreach"
        component={FieldBuyerOutreach}
        customOnChange={(buyerOutreach: BuyerOutreach) =>
          patchListingValue({ buyerOutreach: buyerOutreach || null })
        }
        isRequired={isListingNoPackage}
        {...(isListingNoPackage && { validate: validate.required() })}
      />

      <Field
        name="mediaPackage"
        component={FieldMediaPackages}
        customOnChange={(mediaPackage: MediaPackage) =>
          patchListingValue({ mediaPackage: mediaPackage || null })
        }
      />

      <p className="get-buyers__disclaimer">{t('pricesExcludeGST')}</p>
    </div>
  );
};

export default MeadiaBuying;
